import { useParams } from "react-router-dom";
import { useState,useEffect } from "react";
import { lensClient } from "../../client/LensClient";
import "./profileStyles.css"
import dp from "../../images/ls1.png";
import cp from "../../images/cv.jpg";
import moment from 'moment';
import { MediaRenderer } from "@thirdweb-dev/react";
import { Link } from "react-router-dom";
import { AddReaction } from "../../components/PostInteractions/addReaction";
import { Collect } from "../../components/PostInteractions/collect";
import { Mirror } from "../../components/PostInteractions/mirror";
import { UseFollow } from "../../components/Follow";
import {TailSpin} from 'react-loader-spinner';
import { PublicationType } from "@lens-protocol/client";

export default function ProfileMirrors(){
    const {hdl} = useParams();
    const [data, setData] = useState();
    const [posts,setPosts] = useState();

    useEffect(()=>{
      async function fetchProfiles(){
        const profileByHandle = await lensClient.profile.fetch({
          forProfileId: hdl,
        })
        setData(profileByHandle);
        const result = await lensClient.publication.fetchAll({
          where: {
            from: [hdl],
            publicationTypes:[PublicationType.Mirror]
          },
        });
        setPosts(result.items);
      }
      fetchProfiles();
  },[data,posts])

  return(
    <div className="profilePage">      
          <div className="">
            {data==null?<div className="spinner">
                <TailSpin height={150}></TailSpin>
          </div>:
            <>
          {data.metadata?.coverPicture?.optimized?.uri==null?
            <img src = {cp} className="banner"
                alt = {data.handle?.localname}/>
            :
           <img src = {data.metadata.coverPicture.optimized.uri} className="banner"
           alt = {data.handle?.localname}/>
          }
      <div className="profile">
        <div className="profileLeft">
        {data.metadata?.picture?.optimized?.uri==null?
            <MediaRenderer src = {dp} alt = {data.handle?.localname} className="profileImg"/>
            :
            <MediaRenderer src = {data.metadata?.picture?.optimized?.uri} className="profileImg"
                alt = {data.handle?.localname}/>
        }
         
        <div className="info">
            <div className="pname">{data.metadata?.displayName || "Anonymous User"}</div>
            <div className="phandle">{data.handle?.localName|| ""}</div>
            <div className="pbio">{data.metadata?.bio || "anonymous"}</div>
            <div className = "attr">
            {data.metadata?.attributes?.map((itm)=>(
              <>
              <div className = "follow">
                <div>{itm.key}:</div>
                <div>{itm.value}</div>
              </div>
              </> 
            ))}
          </div>
            <div className="follow">
              <div>Followers:</div>
              <div>{data.stats.followers}</div>
            </div>
            <div className="follow">
              <div>Following:</div>
              <div>{data.stats.following}</div>
            </div>
            <UseFollow id={[hdl,]}/>
          </div>
        </div>
        <div className="profileRight">
          <div className="postsType">
            <div className="tab">
              <Link to = {`/profile/${hdl}`}>Posts</Link>
              <Link to={`/profile/nfts/${hdl}`} > Nfts</Link>
              <Link to = {`/profile/mirrors/${hdl}`}>Mirrors</Link>
            </div>
          </div>

        {posts==null?<div className="spinner">
                <TailSpin height={150}></TailSpin>
          </div>:<>
          {posts!=null?<>
        {posts.map((publication) =>(
                <>
                <div className="card">
                <div className="feedPostHeader">

                    {publication.by.metadata?.picture?.optimized?.uri==null?
                     <MediaRenderer src = {dp} className="feedPostProfilePicture" 
                     alt = {publication.by.handle?.fullHandle}/>
                    :
                    <MediaRenderer src = {publication.by.metadata?.picture?.optimized?.uri} className="feedPostProfilePicture"
                        alt = {publication.by.handle?.fullHandle}/>
                    }

                <div className="pos">posted by </div>
                <div className="name">
                    <Link to = {`/profile/${publication.by.id}`}>{publication.by.handle?.localName}</Link>
                </div>
                <div className="updated">
                    <p> about {moment(publication.mirrorOn?.createdAt).fromNow()}</p>
                </div>
                </div>
                <div className="feed">
                    <h4 className="feedTitle">{publication.mirrorOn?.metadata?.content}</h4>
                {publication.mirrorOn?.metadata?.attachments==null?
                null:
                <>
                {publication.mirrorOn?.metadata?.attachments?.length==0?null:
                    <>{publication.mirrorOn?.metadata?.attachments[0]?.audio?<MediaRenderer src={publication.mirrorOn?.metadata?.attachments[0]?.audio?.optimized?.uri} className="feedImage"
                    alt={publication.mirrorOn?.metadata?.attachments?.content || ""}/>
                      :
                    <>
                    {publication.mirrorOn?.metadata?.attachments[0]?.video?
                    <MediaRenderer src={publication.mirrorOn?.metadata?.attachments[0]?.video?.optimized?.uri} className="feedImage"
                            alt={publication.mirrorOn?.metadata?.attachments?.content || ""}/>
                    :<MediaRenderer src={publication.mirrorOn?.metadata?.attachments[0]?.image?.optimized?.uri} className="feedImage"
                    alt={publication.mirrorOn?.metadata?.attachments?.content || ""}/>}
                    </>
                      }
                </>}</>} 
                </div>
                <div className="feedPostFooter">
                    <p> <AddReaction id = {[publication.id,hdl]}/>{publication.mirrorOn?.stats?.upvotes}</p>
                    <p> <Collect id = {[publication.id,hdl]}/>{publication.mirrorOn?.stats?.collects}</p>
                    <p> <Mirror id = {[publication.id,hdl]}/>{publication.mirrorOn?.stats?.mirrors}</p>
                </div>
            </div>
            </>
            ))}</>:<div  className="notfound"><h2>{data.handle?.localname} has no posts yet.</h2></div>}
            </>}
      </div>
      </div>
      </>
      }
    </div>
    </div> 
  );
}